module.exports = __webpack_public_path__ + "static/media/27OCHA6.02c2806d.jpg";